import OverViewIcon from "../Icons/OverViewIcon";
//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
import { Outlet } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { getKey } from "../helpers/sessionKey";
import WelcomeIcon from "../Icons/WelcomeIcon";
import useGetHook from "../customHooks/useGetHook";
import APIS from "../constant/Endpoint";
import { useEffect, useState } from "react";
export const shouldShowWelcome = getKey("shouldShowWelcome");

const DashboardLayout = () => {
  const { data, isLoading } = useGetHook({
    queryKey: ["forms"],
    url: `${APIS.FORM}`,
    params: {
      pin: true,
      limit: 10,
      offset: 0,
    },
  });

  const [navigation, setNavigation] = useState<any>([
    {
      name: "Dashboard",
      href: "",
      icon: "",
      children: [
        ...(shouldShowWelcome === "true" || shouldShowWelcome === null
          ? [
              {
                name: "Welcome",
                href: "/form-builder",
                icon: WelcomeIcon,
                activeIcon: WelcomeIcon,
              },
              {
                name: "Overview",
                href: "/form-builder/overview",
                icon: OverViewIcon,
                activeIcon: OverViewIcon,
              },
            ]
          : [
              {
                name: "Overview",
                href: "/form-builder",
                icon: OverViewIcon,
                activeIcon: OverViewIcon,
              },
            ]),
      ],
    },
    {
      name: "Pinned Forms",
      href: "",
      icon: "",
      children: [],
    },
    {
      name: "Dynamic Forms",
      href: "",
      icon: "",
      children: [
        {
          name: "Forms",
          href: "/form-builder/forms",
          icon: OverViewIcon,
          activeIcon: OverViewIcon,
        },
        {
          name: "Wizards",
          href: "/form-builder/wizards",
          icon: OverViewIcon,
          activeIcon: OverViewIcon,
        },
        {
          name: "Data Collection",
          href: "/form-builder/data-collected",
          icon: OverViewIcon,
          activeIcon: OverViewIcon,
        },
      ],
    },
  ]);
  useEffect(() => {
    if (!data?.results) return;

    const pinned = data.results.filter((form: any) => form.pin === true);

    setNavigation((prevNav: any) => {
      return prevNav.map((item: any) => {
        if (item.name !== "Pinned Forms") return item;

        return {
          ...item,
          children: pinned.map((form: any) => ({
            name: form.title,
            href: `/form-builder/data-collect/${form.id}`,
            icon: OverViewIcon,
            activeIcon: OverViewIcon,
          })),
        };
      });
    });
  }, [data]);

  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw` h-full p-2 overflow-y-auto`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
